import { useState, useEffect } from 'react';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `useApi | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
export const callApi = (url, options) => {
    return fetch(url, options)
        .then(checkForErrors)
        .then((response) => response.json());
};
export const useApi = (url, options) => {
    const [request, setRequest] = useState({
        loading: true,
    });
    useEffect(() => {
        callApi(url, options)
            .then((data) => {
            setRequest({
                data,
                loading: false,
            });
        })
            .catch((error) => {
            setRequest({
                error,
                loading: false,
            });
        });
    }, [url, options]);
    return request;
};
